import { Injectable } from '@angular/core';
import { birthdaysImage } from './base-images/birthdays';
import { errorImage } from './base-images/error';
import { reviewsImage } from './base-images/reviews';
import { ThemedImageKey } from './themed-images.model';

@Injectable({ providedIn: 'root' })
export class ThemedImagesService {
  themedImage(key: ThemedImageKey): string {
    switch (key) {
      case 'birthdays':
        return this.applyTheme(birthdaysImage);
      case 'error':
        return this.applyTheme(errorImage);
      case 'reviews':
        return this.applyTheme(reviewsImage);
      default:
        throw new Error(`Unknown themed image key: ${key}`);
    }
  }

  applyTheme(svg:string): string {
    // Determine theme color based on URL
    if (window.location.href.includes('adviserconnect')) {
      return this.replaceColors(svg, '#EC2326');
    } else if (window.location.href.includes('consultm')) {
      return this.replaceColors(svg, '#188BAC');
    } else {
      return svg; // No theming if URL doesn't match known patterns
    }
  }

  private replaceColors(svg: string, themeColor: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');

    if (!svgElement) return svg;

    // Colors in the source SVG that should be "themeable"
    const replaceableFills = new Set(['#000']);
    const replaceableStrokes = new Set(['#000']);

    // Helper to normalize colors
    const norm = (v: string | null) => (v ?? '').trim().toLowerCase();

    // Fill: only replace if it's one of the replaceable colors
    svgElement.querySelectorAll<SVGElement>('[fill]').forEach((el) => {
      const fill = norm(el.getAttribute('fill'));
      if (replaceableFills.has(fill)) {
        el.setAttribute('fill', themeColor);
      }
    });

    // Stroke: only replace if it's one of the replaceable colors
    svgElement.querySelectorAll<SVGElement>('[stroke]').forEach((el) => {
      const stroke = norm(el.getAttribute('stroke'));
      if (replaceableStrokes.has(stroke)) {
        el.setAttribute('stroke', themeColor);
      }
    });

    return new XMLSerializer().serializeToString(svgElement);
  }
}
